











































































import { Component, Prop, Vue } from "vue-property-decorator";
import ApexCharts from "vue-apexcharts";
import AdUnitsSelector from "@/components/AdUnitsSelector.vue";
import SitesSelector from "@/components/SitesSelector.vue";
import DatePicker from "@/components/DatePicker.vue";
import ReportsAPI from "@/services/reports";
import moment from "moment";
import DefinitionsSelector from "@/components/DefinitionsSelector.vue";
import { AdUnitFilter } from "@/models/adUnit";
import { BehaviorReport as BehaviorReportInterface } from "@/models/reports";
import { LayoutModule } from "@/store/layout";
import { exportCSVFile } from "@/helpers/general";

@Component({
  components: {
    ApexCharts,
    AdUnitsSelector,
    SitesSelector,
    DatePicker,
    DefinitionsSelector,
  },
})
export default class BehaviorReport extends Vue {
  filter = {
    site_id: [],
    ad_units: [],
    definitionValues: [],
    dates: {
      start: "",
      end: "",
    },
  };
  dates: string[] = [moment().subtract(1, "M").format(), moment().format()];
  data: BehaviorReportInterface[] = [];

  get loading(): boolean {
    return LayoutModule.loaderIsVisible;
  }

  async created(): Promise<void> {
    // console.log("created");
    // await this.getData();
  }

  get options() {
    return {
      chart: {
        type: "area",
        height: 750,
      },
      title: {
        text: "Comportamiento",
      },
      dataLabels: {
        enabled: false,
      },
      xaxis: {
        type: "datetime",
      },
      yaxis: [
        {
          title: {
            text: this.$t("reports.campaign.prints"),
          },
        },
        {
          opposite: true,
          title: {
            text: this.$t("reports.campaign.clicks"),
          },
        },
      ],
    };
  }

  get series() {
    return [
      {
        name: this.$t("reports.campaign.prints"),
        type: "area",
        data: this.data.map((e) => {
          return [moment(e.date).toDate().getTime(), e.prints];
        }),
      },
      {
        name: this.$t("reports.campaign.clicks"),
        type: "area",
        data: this.data.map((e) => {
          return [moment(e.date).toDate().getTime(), e.clicks];
        }),
      },
    ];
  }

  get adUnitFilters(): AdUnitFilter {
    const filter = {
      filter: {
        site_ids: this.filter.site_id,
      },
      fields: {
        ad_unit: ["id", "ref", "name", "definition_value_ids"].join(","),
      },
      page: {
        size: -1,
      },
    };
    return filter;
  }

  async getData(): Promise<void> {
    const payload = { ...this.filter };
    this.data = [];

    try {
      payload.dates.start = this.dates[0];
      payload.dates.end = this.dates[1];
      const r = await ReportsAPI.behaviorReport(this.filter);

      this.data = r;
    } catch (e) {
      console.log(e);
    }
  }

  exportCsv(): void {
    const headers: string[] = ["date", "prints", "clicks"];
    const data: any = [];
    this.data.forEach((d) => {
      const item = {
        date: moment(d.date).format("DD/MM/YYYY"),
        prints: d.prints,
        clicks: d.clicks,
      };
      data.push(item);
    });

    exportCSVFile(
      headers,
      data,
      `behavior_report_${moment().format("YYYY_MM_DD")}`
    );
  }
}
